var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('worker',{attrs:{"title":"在职员工信息管理","fun-auth-other":_vm.funAuth,"isDiscipline":"no"}})}
var staticRenderFns = []

export { render, staticRenderFns }